"use strict";

const MuniLiftStationsPopup = function () {
  var getPopupHtml = function (properties) {
    properties.permissions = UserPermissions.getAllPermissions();
    properties.canEditInventory = HardAssetInventoryModalController.canEditInventory("liftStation");
    properties.canCreateRoutineInspection =
      properties.canCreateRoutineInspection &&
      HardAssetInspectionGate.isEnabledForAssetType("liftStation");
    return PopupContent.getLayerPopup(properties, "muniLiftStations");
  };

  var onPopupOpen = async function (properties, layerName) {
    const id = properties.id;
    var data = await getPopupData(id);
    const html = getPopupHtml(data);
    $(".leaflet-popup-content").html(html);
    const $popup = $(".leaflet-popup-content");
    const layerModule = LayerFunctions.getLayerModule(layerName);
    onPopupOpenWithData(data, $popup, layerModule.invalidateLayerData);
  };
  var onPopupOpenWithData = function (data, $element, invalidateLayerDataFunction) {
    var onPopupDelete = function () {
      deleteliftStation(data.id, data.name, invalidateLayerDataFunction);
    };

    $element.off("click", ".popup-delete-button", onPopupDelete);
    $element.on("click", ".popup-delete-button", onPopupDelete);

    MuniPopup.bindListeners($element, invalidateLayerDataFunction);
    MuniPopup.renderInspectionHistory(
      data.history,
      "liftStation",
      data.id,
      data.canCreateRoutineInspection,
    );
  };
  var deleteliftStation = function (id, name, invalidateLayerDataFunction) {
    const popupCloseButn = $(".leaflet-popup-close-button");
    MessageModal.showConfirmWarningModal(
      `Delete Lift Station ${name}? Click "Delete" to permanently delete the Lift Station. Click "Cancel" to return.`,
      async function () {
        await ApiCalls.deleteLiftStation(id);
        invalidateLayerDataFunction();
        _reloadAndClosePopup(popupCloseButn);
      },
      "Cancel",
      "Delete",
    );
    Analytics.sendPopupEvent("delete_asset", "lift-stations");
  };

  var _reloadAndClosePopup = function (popupCloseButn) {
    if (popupCloseButn.length) {
      popupCloseButn[0].click();
    }
  };

  var getPopupData = async function (id) {
    const popupData = await ApiCalls.getMuniLiftStationsPopup(id);
    const condition = popupData.lastMaintenanceInspection?.condition ?? null;
    popupData.icon = {
      class: RoutineMaintenanceIcon.getConditionClass("muni-lift-stations", condition),
      color: RoutineMaintenanceIcon.getConditionColor(condition),
    };

    return popupData;
  };

  return {
    getPopupHtml,
    onPopupOpen,
  };
};

module.exports = MuniLiftStationsPopup();

const ApiCalls = require("../apiCalls");
const PopupContent = require("../mapFunctions/popupContent");
const LayerFunctions = require("../layerFunctions");
const MessageModal = require("../modals/messageModal");
const UserPermissions = require("../login/userPermissions");
const HardAssetInspectionGate = require("./hardAssetInspectionGate");
const HardAssetInventoryModalController = require("./hardAssetInventoryModalController");
const Analytics = require("../general/analytics");
const MuniPopup = require("./muniPopup");
const RoutineMaintenanceIcon = require("../general/routineMaintenanceIcon");
